/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useCallback, useState } from 'react';
import * as Yup from 'yup';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import { Row, Column } from '../../../../styles/components';
import Input from '../../../../components/Input';
import getValidationErrors from '../../../../utils/getValidationErrors';
import TableLoader from '../../../../components/TableLoader';
import { Container } from './styles';

interface CreateCardOrderModalProps {
  show: boolean;
  title: string;
  handleClose(): void;
  handleAdd(quantity: string): void;
}

const schema = Yup.object().shape({
  quantity: Yup.string().required('Quantidade é obrigatória'),
});

const CreateCardOrderModal: React.FC<CreateCardOrderModalProps> = ({
  handleClose,
  handleAdd,
  show,
  title,
}) => {
  const formRef = useRef<FormHandles>(null);
  const [loader, setLoader] = useState<boolean>();

  const handleSubmit = useCallback(async (data: any) => {
    try {
      formRef.current?.setErrors({});
      await schema.validate(data, {
        abortEarly: false,
      });
      setLoader(true);
      await handleAdd(data.quantity);
      setLoader(false);
      handleClose();
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        formRef.current?.setErrors(errors);
        return;
      }
      setLoader(false);
    }
  }, []);
  return (
    <Container>
      <Modal show={show} title={title} handleClose={handleClose}>
        {loader ? (
          <TableLoader />
        ) : (
          <Form ref={formRef} onSubmit={handleSubmit}>
            <div className="textContainer">
              <p>
                Para pedidos de segunda via, é necessário aguardar até 72 horas
                após o bloqueio para realizar a retirada dos novos cartões.
              </p>
              <p>
                Os cartões adicionais serão cedidos no posto Floresta, mediante
                apresentação do código de titular da empresa, documento que
                comprove a quantidade total de funcionários da empresa nos
                últimos 30 dias (cópia do CAGED ou cópia Carteira de
                Trabalho/Contrato de Estágio ou Evento 2200 todos no e-social).
              </p>

              <p>
                No ato da retirada dos cartões, o total de cartões possuídos
                pela empresa não deverá ultrapassar a quantidade total de
                funcionários da empresa no ato da retirada dos mesmos.
              </p>

              <p>
                Não serão cedidos novos cartões BHBUS, caso sua empresa possua
                cartões sem pedido de carga por mais de 90 dias e/ou bloqueados
                sem emissão de segunda via.
              </p>

              <p>
                Após a solicitação do pedido, dentro de 24 horas os cartões
                estarão disponíveis para retirada no Posto Floresta.
              </p>
              <Row>
                <Column small="5" medium="5" large="5">
                  <Input
                    label="Quantidade de Cartões"
                    name="quantity"
                    placeholder="Quantidade de cartões"
                    type="number"
                    min="1"
                    schema={schema}
                  />
                </Column>
              </Row>
              <div className="buttonsContainer">
                <Button color="orange" padding="1" type="submit">
                  Solicitar
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Modal>
    </Container>
  );
};

export default CreateCardOrderModal;
